import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages, paramsToSearch } from '@api/utils'

const api = {
  all: (body: ControleQualiteFiltreRequest) =>
    fetchPages<ControleQualiteResponse>('controles', config.ws.controle.all, 'POST', body),
  search: (body: ControleQualiteFiltreRequest, page: number, sort: string) =>
    ws<ControleQualiteListResponse>(config.ws.controle.all + `?page=${page}&sort=${sort}&size=250`, 'POST', body),
  get: (id: string) => ws<ControleQualiteResponse>(config.ws.controle.get.replace('{controleQualiteId}', id), 'GET'),
  create: (body: ControleQualiteCreationRequest) =>
    ws<ControleQualiteResponse>(config.ws.controle.create, 'POST', body),
  metier: () => ws<ControleQualiteMetierListResponse>(config.ws.controle.metier, 'GET'),
  question: () => ws<ControleQualiteQuestionListResponse>(config.ws.controle.question, 'GET'),
  stats: (body: Partial<HistoryBody>) =>
    ws<ControleQualiteStatistiqueResponse>(config.ws.controle.stats + paramsToSearch(body), 'GET'),
  historique: (body: HistoryBody) =>
    ws<ControleQualiteHistoriqueListResponse>(config.ws.controle.historique + paramsToSearch(body), 'GET'),

  delete: (id: string) => ws<void>(config.ws.controle.delete.replace('{controleQualiteId}', id), 'DELETE'),

  filtres: {
    espace: (siteId: string) =>
      fetchPages<ControleQualiteBasicLocalisationResponse>(
        'localisations',
        config.ws.controle.filtres.espace + paramsToSearch({ siteId }),
        'GET'
      ),
    manifestation: (siteId: string) =>
      fetchPages<ControleQualiteBasicManifestationResponse>(
        'manifestations',
        config.ws.controle.filtres.manifestation + paramsToSearch({ siteId }),
        'GET'
      ),
    metier: (siteId: string) =>
      fetchPages<ControleQualiteBasicMetierResponse>(
        'metiers',
        config.ws.controle.filtres.metier + paramsToSearch({ siteId }),
        'GET'
      ),
    societe: (siteId: string) =>
      fetchPages<ControleQualiteBasicSocieteResponse>(
        'societes',
        config.ws.controle.filtres.societe + paramsToSearch({ siteId }),
        'GET'
      ),
  },
}

export default api
